import type { IconSvgObject } from './types';

const StrokeRightIcon: IconSvgObject = [
  ["path", { d: "M17 5H5C3.89543 5 3 5.89543 3 7V17C3 18.1046 3.89543 19 5 19H17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M20.998 21L20.998 3", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default StrokeRightIcon;
